// IRAS Integration Configuration
// This file centralizes all IRAS-related configuration for easy switching between demo and production

export const IRAS_CONFIG = {
  // Demo/Production Mode Toggle
  IS_DEMO_MODE: true, // TODO: Set to false when using actual IRAS API
  
  // IRAS API Endpoints (Production)
  // TODO: Replace with actual IRAS API endpoints when subscription approved
  PRODUCTION_ENDPOINTS: {
    BASE_URL: 'https://api.iras.gov.sg',
    AUTH_URL: 'https://auth.corppass.gov.sg/oauth2/authorize',
    TOKEN_URL: 'https://auth.corppass.gov.sg/oauth2/token',
    VALIDATE_URL: 'https://api.iras.gov.sg/auth/validate',
    GST_SUBMIT_URL: 'https://api.iras.gov.sg/gst/submit',
    FORM_CS_SUBMIT_URL: 'https://api.iras.gov.sg/tax/form-cs/submit',
    SUBMISSIONS_URL: 'https://api.iras.gov.sg/submissions'
  },
  
  // Demo Configuration
  DEMO_CONFIG: {
    SIMULATION_DELAY: 1500, // ms - Time to simulate SingPass authentication
    SUCCESS_RATE: 0.95, // 95% success rate for demo submissions
    MOCK_CLIENT_ID: 'DEMO_CLIENT_ID_TAX_SAVY',
    DEMO_NOTICES: {
      AUTH_CARD: '🚀 DEMO MODE: This is a demonstration using mock IRAS API responses. Real integration pending approval.',
      DASHBOARD: '🚀 DEMO MODE: Using mock IRAS API responses with simulated data',
      AUTH_PROCESS: '🚀 DEMO: Simulating SingPass CorpPass authentication process. In production, you will be redirected to the official SingPass login page.'
    }
  },
  
  // OAuth 2.0 Configuration
  OAUTH_CONFIG: {
    RESPONSE_TYPE: 'code',
    SCOPE: 'read',
    // TODO: Update with actual client credentials when approved
    CLIENT_ID: process.env.REACT_APP_IRAS_CLIENT_ID || 'DEMO_CLIENT_ID',
    CLIENT_SECRET: process.env.REACT_APP_IRAS_CLIENT_SECRET || 'DEMO_CLIENT_SECRET'
  },
  
  // Security Configuration
  SECURITY_CONFIG: {
    STATE_LENGTH: 32, // bytes for CSRF protection
    TOKEN_STORAGE_KEY: 'iras_access_token',
    STATE_STORAGE_KEY: 'corppass_state',
    TOKEN_EXPIRY_BUFFER: 300, // seconds - refresh token 5 minutes before expiry
    /** Client hints after backend IRAS OAuth (token lives server-side) */
    SERVER_OAUTH_CONNECTED_KEY: 'iras_corp_pass_connected',
    SERVER_OAUTH_EXPIRES_AT_KEY: 'iras_corp_pass_expires_at',
  },

  // Feature flags
  FEATURE_FLAGS: {
    // true: enforce pre-submit validation (filing info, data form, declaration)
    // false: bypass all pre-submit validation gates
    ENABLE_FORM_CS_PRE_SUBMIT_VALIDATION: false,
  },
  
  // Application URLs
  APP_URLS: {
    // TODO: Update with actual production URLs
    CALLBACK_URL: process.env.REACT_APP_IRAS_CALLBACK_URL || '/consolePanel',
    SUCCESS_REDIRECT: '/company?activeTab=2&authSuccess=true',
    ERROR_REDIRECT: '/company?activeTab=2&authError=true'
  }
};

// Helper function to get the appropriate API service
export const getIrasApiService = async () => {
  if (IRAS_CONFIG.IS_DEMO_MODE) {
    // Return mock API for demo
    const { mockIrasAPI } = await import('../services/mockIrasAPI');
    return mockIrasAPI;
  } else {
    // TODO: Return actual IRAS API service when implemented
    // const { productionIrasAPI } = await import('../services/productionIrasAPI');
    // return productionIrasAPI;
    throw new Error('Production IRAS API not yet implemented. Please set IS_DEMO_MODE to true.');
  }
};

// Helper function to get demo notices
export const getDemoNotice = (type) => {
  return IRAS_CONFIG.DEMO_CONFIG.DEMO_NOTICES[type] || '';
};

// Helper function to check if in demo mode
export const isDemoMode = () => {
  return IRAS_CONFIG.IS_DEMO_MODE;
};

export default IRAS_CONFIG;
